import Vue from "vue";
import Router from "vue-router";
import { access } from "./mixins/constant";
import { intersection, startCase } from "lodash";
// import PageNotFound from '@/components/PageNotFound.vue'

Vue.use(Router);

let router = new Router({
  base: process.env.BASE_URL,
  mode: "history",
  routes: [
    {
      path: "/",
      name: "LogIn",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/LogIn.vue"),
    },
    // below for broker dashboard only
    {
      path: "/broker-dashboard-analytics",
      name: "BrokerDashboardAnalytics",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokerDashboardAnalytics.vue"),
      meta: {
        requiresAuth: true,
        access: [access.BROKER_ADMIN],
      },
    },

    // below routing of user details for admin dashboard only
    {
      path: "/sa-dashboard-analytics",
      name: "SADashboardAnalytics",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/StockAntsAdminDashboard.vue"),
      meta: {
        requiresAuth: true,
        access: [access.STOCKANTS_ADMIN],
      },
    },
    {
      path: "/trade-dashboard-analytics",
      name: "tradeDashboardAnalytics",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/TradeDashboard.vue"),
      meta: {
        requiresAuth: true,
        access: [access.STOCKANTS_ADMIN, access.BROKER_ADMIN],
      },
    },
    {
      path: "/user-plans",
      name: "UserPlans",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/UserPlansManagement.vue"),
      meta: {
        requiresAuth: true,
        access: [access.STOCKANTS_ADMIN],
      },
    },
    // {
    //   path: "/dashboard",
    //   name: "DashBoard",
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./components/DashBoard.vue"),
    //   meta: {
    //     requiresAuth: true,
    //     access: [access.STOCKANTS_ADMIN],
    //   },
    // },
    {
      path: "/chat-dashboard",
      name: "ChatDashBoard",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/ChatDashboard.vue"),
      meta: {
        requiresAuth: true,
        access: [access.STOCKANTS_ADMIN],
      },
    },
    {
      path: "/hotcontrols",
      name: "HotControls",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/HotControls.vue"),
      meta: {
        requiresAuth: true,
        access: [access.STOCKANTS_ADMIN],
      },
    },
    {
      path: "/expert-view",
      name: "ExpertView",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/ExpertView.vue"),
    },
    {
      path: "/user_plans/:query?",
      meta: {
        requiresAuth: true,
        access: [access.STOCKANTS_ADMIN],
      },
      props(route) {
        return route.params || {};
      },
    },
    {
      path: "/create-user",
      name: "CreateUser",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/CreateUser.vue"),
      meta: {
        requiresAuth: true,
        access: [access.STOCKANTS_ADMIN],
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
// Scroll to top on route change
router.afterEach(() => {
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("token"); // Example check for auth token
  var roles = JSON.parse(localStorage.getItem("userRoles")) || [];

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        path: "/",
        // query: { redirect: to.fullPath },
      });
    } else {
      console.log("Authenticated User");
      // const roles = localStorage.getItem("userRoles");
      const authorizedRoles = to.meta.access || [];

      console.log(authorizedRoles);
      console.log(roles);

      const userHasAccess = roles.some((role) =>
        authorizedRoles.includes(role)
      );

      console.log(userHasAccess);

      if (!userHasAccess) {
        // Redirect to an appropriate page if user doesn't have access
        console.log("user has not access");
        if (roles.includes("StockAnts Admin")) {
          next({
            path: "/sa-dashboard-analytics",
          });
        } else if (roles.includes("Broker Admin")) {
          next({
            path: "/broker-dashboard-analytics",
          });
        } else if (roles.includes("Broker Associate")) {
          next({
            path: "/expert-view",
          });
        } else {
          localStorage.clear(true);
          next({
            name: "LogIn",
          });
        }
      } else {
        next();
      }
    }
  } else {
    // Redirect logged-in users trying to access the login page to the dashboard
    if (
      isAuthenticated &&
      roles.includes("StockAnts Admin") &&
      to.path === "/"
    ) {
      next({
        path: "/sa-dashboard-analytics",
        // query: { redirect: to.fullPath },
      });
    } else if (
      isAuthenticated &&
      roles.includes("Broker Admin") &&
      to.path === "/"
    ) {
      next({
        path: "/broker-dashboard-analytics",
        // query: { redirect: to.fullPath },
      });
    } else if (
      isAuthenticated &&
      roles.includes("Broker Associate") &&
      to.path === "/"
    ) {
      next({
        path: "/expert-view",
      });
    } else {
      next();
    }
  }
});

export default router;
